module.exports = __webpack_public_path__ + "icons/icon-download.41319bed.svg";